import React, { CSSProperties, ReactNode, useCallback, useEffect, useRef, useState } from 'react';
import { H5, Paragraph } from '../heading';
import * as styles from './index.module.less';
import { PublicArrowUpOutlined } from 'notta-web-icon';
import { throttle } from 'lodash';

interface IProps {
  title: ReactNode | string;
  content: ReactNode | string;
  defaultOpen?: boolean;
  contentClass?: string;
  titleClass?: string;
  arrowClass?: string;
  style?: CSSProperties;
  isShowArrow?: boolean;
  onChange?: (isOpen: boolean) => void;
}

const Collapse = ({
  title,
  content,
  defaultOpen = false,
  contentClass = '',
  titleClass = '',
  arrowClass = '',
  isShowArrow = true,
  style,
  onChange = () => {},
}: IProps) => {
  const isTitleIsString = typeof title === 'string';
  const isContentIsString = typeof content === 'string';
  const collapseRef = useRef<any>(null);
  const arrowRef = useRef<any>(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleQuestionClick = useCallback(() => {
    arrowRef.current?.classList?.toggle(styles.collapse_arrow_active);
    const [, contentDom]: any[] = Array.from(collapseRef.current.children);
    if (window.getComputedStyle(contentDom).maxHeight === '0px') {
      contentDom.style.maxHeight = contentDom.scrollHeight + 'px';
      onChange(true);
      setIsOpen(true);
    } else {
      contentDom.style.maxHeight = '0px';
      onChange(false);
      setIsOpen(false);
    }
  }, [onChange]);

  useEffect(() => {
    if (defaultOpen) {
      handleQuestionClick();
    }
  }, [defaultOpen, handleQuestionClick]);

  const handleSetMaxH = throttle(() => {
    const [, contentDom]: any[] = Array.from(collapseRef.current.children);

    if (isOpen) {
      contentDom.style.maxHeight = contentDom.scrollHeight + 'px';
    } else {
      contentDom.style.maxHeight = '0px';
    }
  }, 300);

  useEffect(() => {
    handleSetMaxH();
    window.addEventListener('resize', handleSetMaxH);

    return () => {
      window.removeEventListener('resize', handleSetMaxH);
    };
  }, [handleSetMaxH, isOpen]);

  return (
    <div className={styles.collapse_container} ref={collapseRef} style={style}>
      <div className={`${styles.title} ${titleClass}`} role="button" aria-label="button" onClick={handleQuestionClick}>
        {isTitleIsString ? (
          <H5 as="p" style={{ marginBottom: '0' }}>
            {title}
          </H5>
        ) : (
          title
        )}
        {isShowArrow && (
          <div className={`${styles.collapse_arrow} ${arrowClass}`} ref={arrowRef}>
            <PublicArrowUpOutlined />
          </div>
        )}
      </div>
      <div className={`${styles.content} ${contentClass}`}>
        {isContentIsString ? <Paragraph>{content}</Paragraph> : content}
      </div>
    </div>
  );
};
export default Collapse;
